import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../Constants/baseConstant";
import { getUserData, getUserId } from "../../Base/helper/baseFunctions";

export const GetTaxDeclarationHelper = async (params) => {
  var data = getUserData();
  return await axiosInstance(`/finance/getTaxDeclaration`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: data.domain,
      emp_id: params?.employee_id,
    },
  })
    .then((res) => {
      return {
        message: "Tax Declaration Retrived Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};
export const AddTaxDeclarationHelper = async (params) => {
  var data = getUserData();
  toast.info("Saving...");
  return await axiosInstance(`/finance/addTaxDeclaration`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: data.domain,
      emp_id: data.employee_id,
      emptd: params?.emptd || null,
      emplp: params?.emplp || null,
      emphp: params?.emphp || null,
      month: params?.month
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Tax Declaration Added Successfully");
      return {
        message: "Tax Declaration Added Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};

export const UpdateTaxDeclarationHelper = async (params) => {
  var data = getUserData();
  toast.info("Saving...");
  return await axiosInstance(`/finance/updateTaxDeclaration`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: data.domain,
      emp_id: data.employee_id,
      emp_tax_declaration_id: params?.id,
      emptd: params?.emptd || null,
      emplp: params?.emplp || null,
      emphp: params?.emphp || null,
      month: params?.month,
      emptd_approver_status: params?.emptd_approver_status,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Tax Declaration Updated Successfully");
      return {
        message: "Tax Declaration Updated Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};
// tax executive
export const GetTaxDeclarationExecutiveHelper = async () => {
  var data = getUserData();
  return await axiosInstance(`/finance/getTaxDeclarationExecutive`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: data.domain,
    },
  })
    .then((res) => {
      return {
        message: "Executive Retrived Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};

export const UpdateTaxDeclarationExecutiveHelper = async (params) => {
  var data = getUserData();
  toast.info("Saving...");
  return await axiosInstance(`/finance/updateTaxDeclarationExecutive`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: data.domain,
      user_id: getUserId(),
      payroll_executive_emp_id: params?.payroll_executive_emp_id,
      finance_executive_emp_id: params?.finance_executive_emp_id,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Executive Updated Successfully");
      return {
        message: "Executive Updated Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};

// tax declaration employee toggle
export const GetTaxEmployeeToggleInfoHelper = async () => {
  var data = getUserData();
  return await axiosInstance(`/finance/getTaxEmployeeToggleInfo`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: data.domain,
    },
  })
    .then((res) => {
      return {
        message: "Employee Toggle Info Retrived Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};

export const UpdateTaxEmployeeToggleInfonHelper = async (params) => {
  var data = getUserData();
  toast.info("Saving...");
  return await axiosInstance(`/finance/updateTaxEmployeeToggleInfo`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: data.domain,
      user_id: getUserId(),
      employee_toggle: params?.employee_toggle || false,
      tax_declaration_flag: params?.tax_declaration_flag || false,
    },
  })
    .then((res) => {
      toast.dismiss();
      if (params?.control_type === "declaration") {
        if (params?.tax_declaration_flag) {
          toast.success("Tax declaration is now enabled for all employees");
        } else {
          toast.success("Tax declaration is now disabled for all employees");
        }
      } else {
        if (params?.employee_toggle) {
          toast.success("Proof upload is now enabled for all employees");
        } else {
          toast.success("Proof upload is now disabled for all employees");
        }      }
      return {
        message: "Updated Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};

// get Admin Tax Declaration
export const GetAdminTaxDeclarationHelper = async (params) => {
  var data = getUserData();
  return await axiosInstance(`/finance/getAdminTaxDeclaration`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: data.domain,
      emp_id: params?.emp_id,
      user_id: getUserId(),
      ats_work_location_json: params?.ats_work_location_json || null,
    },
  })
    .then((res) => {
      return {
        message: "Tax Declaration Retrived Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};
// update employee tax declaration by approver
export const UpdateEmployeeTaxDeclarationHelper = async (params) => {
  var data = getUserData();
  toast.info("Saving...");
  return await axiosInstance(`/finance/updateEmployeeTaxDeclaration`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: data.domain,
      emp_id: params?.employee_id,
      emp_tax_declaration_approved_id: params.emp_tax_declaration_approved_id,
      emptd: params?.emptd || null,
      emplp: params?.emplp || null,
      emphp: params?.emphp || null,
      month: params?.month,
      year: params?.year,
      emp_status: params?.emp_status,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Team Tax Declaration Updated Successfully");
      return {
        message: "Team Tax Declaration Updated Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};

export const UploadTaxDeclarationProofHelper = async (params) => {
  var data = getUserData();
  toast.info("Saving...");
  return await axiosInstance(`/finance/uploadTaxDeclarationProof`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: data?.domain,
      user_id: getUserId(),
      emp_id: data?.employee_id,
      td_component: params?.td_component,
      file_path: params?.filename,
      base64String: params?.b64string,
      content_type: params?.content_type,
      old_file_path: params?.old_file_path,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Proof Saved Successfully");
      return {
        message: "Proof Saved Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};

export const GetTaxReportHelper = async (params) => {
  var data = getUserData();
  return await axiosInstance(`/finance/getTaxReport`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: data.domain,
      emp_id: params?.emp_id,
      from_year: params?.fromYear,
      to_year: params.toYear,
      month: params?.month,
      user_id: String(getUserId())
    },
  })
    .then((res) => {
      return {
        message: "Tax Report Retrived Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};

// /getTaxReportRegimeCalculation

export const GetTaxReportRegimeCalculationHelper = async (params) => {
  var data = getUserData();
  return await axiosInstance(`/finance/getTaxReportRegimeCalculation`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: data.domain,
      taxable_income: params?.taxable_income,
      regime_type: params?.regime_type,
    },
  })
    .then((res) => {
      return {
        message: "Tax Report Slab Calculation Retrived Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};